export default "__VITE_ASSET__DtSajrPV__"